import React, { Suspense, useReducer, useState, useEffect, useRef } from 'react';
import { Tabs, Tab } from 'carbon-components-react';
import ALERT_HEADERS from 'components/ManageAutomationPage/Alerts/data/alert_headers';
import PREDICTED_ALERT_HEADERS from 'components/ManageAutomationPage/Alerts/data/predicted_alert_headers';
import i18n from "../../i18n";
import callGetApi from "../../requests/GetRequests";
import * as Constants from '../../requests/URLConstants';
import RUNNING_ALERT_HEADERS from 'components/ManageAutomationPage/Alerts/data/running_alert_headers';
import ResourceIssues from './ResourceIssues';
import QueueStatus from './QueueAlerts';
import INFRA_ALERT_HEADERS from 'components/ManageAutomationPage/Alerts/data/infra_alert_headers';
import AUTOMATION_INFRA_ALERT_HEADERS from 'components/ManageAutomationPage/Alerts/data/automation_infra_alert_headers';
import AUTOMATION_INFORMATIONAL_HEADERS from 'components/ManageAutomationPage/Alerts/data/automation_informational_headers';


var config = require('../../config/appConfig.json');

const Alerts = React.lazy(() => import('components/ManageAutomationPage/Alerts/Alerts'));

const tabProps1 = {
    tabs: {
        selected: 0,
        type: 'container'
    },
    tab: {
        tabIndex: 0,
    },
};

const tabProps2 = {
    tabs: {
        selected: 0,
        type: 'container'
    },
    tab: {
        tabIndex: 0,
    },
};

function alertFilterDataReducer(state, action) {
    switch (action.type) {
        case "add_franchise":
            return { ...state, franchises: action.item };
        case "add_clients":
            return { ...state, clients: action.item };
        case "add_technologies":
            return { ...state, technologies: action.item };
        case "add_deployment_models":
            return { ...state, deployment_models: action.item };
        case "add_geos":
            return { ...state, geos: action.item };
        case "add_competencies":
            return { ...state, competencies: action.item };
        case "add_priorities":
            return { ...state, priorities: action.item };
        case "add_assignee":
            return { ...state, assignees: action.item };
        case "add_assignee_email":
            return { ...state, assignees_email: action.item };
        case "add_status":
            return { ...state, status: action.item };
        case "add_automata_activity_name":
            return { ...state, automata_activity_name: action.item };
        case "add_automata_state":
            return { ...state, automata_state: action.item };
        case "add_bot_id":
            return { ...state, bot_id: action.item };
        default:
            return { ...state };

    }
}
function pAlertFilterDataReducer(state, action) {
    switch (action.type) {
        case "add_franchise":
            return { ...state, franchises: action.item };
        case "add_clients":
            return { ...state, clients: action.item };
        case "add_deployment_models":
            return { ...state, deployment_models: action.item };
        case "add_incidentStatus":
            return { ...state, incidentStatus: action.item };
        default:
            return { ...state };

    }
}



const AutomationOpsWorkspace = (props) => {
    const [loadedTabs, setLoadedTabs] = useState(['exceptions', 'dependency_failures']);
    const [alertFilterData, alertFilterDispatch] = useReducer(alertFilterDataReducer, { clients: [] });
    const [alertFilterSelections, setAlertFilterSelections] = useState({ 'franchise': [], 'client': [], 'technology': [], 'deployment_model': [], 'geo': [], "competency": [], 'priority': [], 'status': [], 'assignee': [], 'assignee_email': [], 'automata_state': [], 'automata_activity_name': [], 'bot_id': [] });
    const [pAlertFilterData, pAlertFilterDispatch] = useReducer(pAlertFilterDataReducer, { clients: [] });
    const [pAlertFilterSelections, setPAlertFilterSelections] = useState({ 'franchise': [], 'client': [], 'deployment_model': [], 'incidentStatus': [] });
    const [disabledSelects, setDisabledSelects] = useState({ 'client-select': true });
    const [alertHeaders, setAlertHeaders] = useState(ALERT_HEADERS);
    const [runningAlertHeaders, setRunningAlertHeaders] = useState(RUNNING_ALERT_HEADERS);
    const [predictedAlertHeaders, setPredictedAlertHeaders] = useState(PREDICTED_ALERT_HEADERS);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [predictedInfraAlertHeaders, setPredictedInfraAlertHeaders] = useState(AUTOMATION_INFRA_ALERT_HEADERS);
    const [predictedInformationalHeaders, setPredictedInformationalHeaders] = useState(AUTOMATION_INFORMATIONAL_HEADERS);

    let roles = JSON.parse(localStorage.getItem('roles'));

    useEffect(() => {
        if (props.userPrefs && props.userPrefs.alertFilters) { setAlertFilterSelections(props.userPrefs.alertFilters); }
        if (props.userPrefs && props.userPrefs.pAlertFilters) { setPAlertFilterSelections(props.userPrefs.pAlertFilters); }
        // setUserPreferences('elastic');
        // fetch('http://localhost:5000/api/alerts/getAlertsFilterData', {
        // fetch(config.serverUrl + '/api/alerts/getAlertsFilterData', {
        //   method: 'GET',
        //   //  cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        //   credentials: "include",
        //   withCredentials: true,
        //   headers: {
        //     'Content-Type': 'application/json'
        //   },
        //   //   redirect: 'follow', // manual, *follow, error
        //   //    referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        // })
        // .then(response => response.json())
        callGetApi(Constants.GETALERTSFILTERDATAURL, { 'Content-Type': 'application/json' })
            .then(resp => {
                //console.log('response', resp);

                if (resp.aggregations.franchises) {
                    let franchiseList = [];
                    resp.aggregations.franchises.buckets.forEach(element => {
                        let franchise = {};
                        franchise.name = element.key;
                        franchiseList.push(franchise);
                    });
                    alertFilterDispatch({ type: "add_franchise", item: franchiseList });
                }

                if (resp.aggregations.technologies) {
                    let technologiesList = [];
                    resp.aggregations.technologies.buckets.forEach(element => {
                        let technology = {};
                        technology.name = element.key;
                        technologiesList.push(technology);
                    });
                    alertFilterDispatch({ type: "add_technologies", item: technologiesList });
                }

                if (resp.aggregations.deployment_models.buckets) {
                    let deployment_modelsList = [];
                    resp.aggregations.deployment_models.buckets.forEach(element => {
                        let deployment_model = {};
                        deployment_model.name = element.key;
                        deployment_modelsList.push(deployment_model);
                    });
                    alertFilterDispatch({ type: "add_deployment_models", item: deployment_modelsList });
                }

                if (resp.aggregations.geos.buckets) {
                    let geosList = [];
                    resp.aggregations.geos.buckets.forEach(element => {
                        let geo = {};
                        geo.name = element.key;
                        geosList.push(geo);
                    });
                    alertFilterDispatch({ type: "add_geos", item: geosList });
                }

                if (resp.aggregations.competencies.buckets) {
                    let competenciesList = [];
                    resp.aggregations.competencies.buckets.forEach(element => {
                        let competency = {};
                        competency.name = element.key;
                        competenciesList.push(competency);
                    });
                    alertFilterDispatch({ type: "add_competencies", item: competenciesList });
                }

                if (resp.aggregations.priorities.buckets) {
                    let prioritiesList = [];
                    resp.aggregations.priorities.buckets.forEach(element => {
                        let priority = {};
                        priority.name = element.key;
                        prioritiesList.push(priority);
                    });
                    alertFilterDispatch({ type: "add_priorities", item: prioritiesList });
                }

                if (resp.aggregations.assigned_to.buckets) {
                    let assignedList = [];
                    resp.aggregations.assigned_to.buckets.forEach(element => {
                        let assigned = {};
                        assigned.name = element.key;
                        assignedList.push(assigned);
                    });
                    alertFilterDispatch({ type: "add_assignee", item: assignedList });
                }

                if (resp.aggregations.assigned_to_user_id.buckets) {
                    let assignedEmailList = [];
                    resp.aggregations.assigned_to_user_id.buckets.forEach(element => {
                        let assignedEmail = {};
                        assignedEmail.name = element.key;
                        assignedEmailList.push(assignedEmail);
                    });
                    alertFilterDispatch({ type: "add_assignee_email", item: assignedEmailList });
                }
                if (resp.aggregations.status.buckets) {
                    let statusList = [];
                    resp.aggregations.status.buckets.forEach(element => {
                        let status = {};
                        status.name = element.key;
                        statusList.push(status);
                    });
                    alertFilterDispatch({ type: "add_status", item: statusList });
                }

                if (resp.aggregations.automata_activity_name.buckets) {
                    let automataActivityNameList = [];
                    resp.aggregations.automata_activity_name.buckets.forEach(element => {
                        let automata_activity_name = {};
                        automata_activity_name.name = element.key;
                        automataActivityNameList.push(automata_activity_name);
                    });
                    alertFilterDispatch({ type: "add_automata_activity_name", item: automataActivityNameList });
                }

                if (resp.aggregations.automata_state.buckets) {
                    let automataStateList = [];
                    resp.aggregations.automata_state.buckets.forEach(element => {
                        let automata_state = {};
                        automata_state.name = element.key;
                        automataStateList.push(automata_state);
                    });
                    alertFilterDispatch({ type: "add_automata_state", item: automataStateList });
                }

                if (resp.aggregations.bot_id.buckets) {
                    let botIDList = [];
                    resp.aggregations.bot_id.buckets.forEach(element => {
                        let bot_id = {};
                        bot_id.name = element.key;
                        botIDList.push(bot_id);
                    });
                    alertFilterDispatch({ type: "add_bot_id", item: botIDList });
                }

            }).catch((error) => {
                console.error('Error:', error);
            });
        // get filter data for dependency alerts
        // fetch('http://localhost:5000/api/alerts/getPredictedAlertsFilterData', {
        // fetch(config.serverUrl + '/api/alerts/getPredictedAlertsFilterData', {
        //   method: 'GET',
        //   //   cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        //   credentials: "include",
        //   withCredentials: true,
        //   headers: {
        //     'Content-Type': 'application/json'
        //   },
        //   //    redirect: 'follow', // manual, *follow, error
        //   //   referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        // })
        //   .then(response => response.json())
        callGetApi(Constants.GETPREDECTIVEALERTSFILTERDATAURL, { 'Content-Type': 'application/json' })
            .then(resp => {
                //console.log('response', resp);
                if (resp.aggregations.franchises.buckets) {
                    let franchiseList = [];
                    resp.aggregations.franchises.buckets.forEach(element => {
                        let franchise = {};
                        franchise.name = element.key;
                        franchiseList.push(franchise);
                    });
                    pAlertFilterDispatch({ type: "add_franchise", item: franchiseList });
                }
                if (resp.aggregations.deployment_models.buckets) {
                    let deployment_modelsList = [];
                    resp.aggregations.deployment_models.buckets.forEach(element => {
                        let deployment_model = {};
                        deployment_model.name = element.key;
                        deployment_modelsList.push(deployment_model);
                    });
                    pAlertFilterDispatch({ type: "add_deployment_models", item: deployment_modelsList });
                }
                if (resp.aggregations.incidentStatus) {
                    let incidentStatusList = [];
                    resp.aggregations.incidentStatus.buckets.forEach(element => {
                        let incidentStatus = {};
                        incidentStatus.name = element.key;
                        incidentStatusList.push(incidentStatus);
                    });
                    pAlertFilterDispatch({ type: "add_incidentStatus", item: incidentStatusList });
                }
            }).catch((error) => {
                console.error('Error:', error);
            });
    }, [props.userPrefs]);

    useEffect(() => {
        if (props.selectedTab === 'Long Running') {
            setSelectedIndex(1);
            setLoadedTabs([...loadedTabs, 'long_running']);
        }
        else if (props.selectedTab === 'Long Pending') {
            setSelectedIndex(2);
            setLoadedTabs([...loadedTabs, 'long_pending']);
        }
        else if (props.selectedTab === 'Infra Alerts') {
            setSelectedIndex(3);
            setLoadedTabs([...loadedTabs, 'infra_alert_automation']);
        }
        else if (props.selectedTab === 'Informational Alerts') {
            setSelectedIndex(4);
            setLoadedTabs([...loadedTabs, 'informational_automation']);
        }
        else {
            setSelectedIndex(0);
            setLoadedTabs([...loadedTabs, 'dependency_failures']);
        }
    }, [props.selectedTab, props.executionClick])

    const updateState = (state, stateValue, type) => {
        //console.log('got here');
        switch (state) {
            case 'alertFilterSelections':
                setAlertFilterSelections(stateValue);
                props.updateState('userPreferences', { 'alertFilterSelections': stateValue });
                break;
            case 'pAlertFilterSelections':
                setPAlertFilterSelections(stateValue);
                props.updateState('userPreferences', { 'pAlertFilterSelections': stateValue });
                break;
            case 'cardInfo':
                props.updateState('cardInfo', stateValue);
                break;
            case 'disabledSelects':
                setDisabledSelects(stateValue);
                break;
            case 'alertFilterData_clients':
                alertFilterDispatch({ type: "add_clients", item: stateValue });
                break;
            case 'pAlertFilterData_clients':
                pAlertFilterDispatch({ type: "add_clients", item: stateValue });
                break;
            case 'alertHeaders':
                if (type === 'Alert') {
                    setAlertHeaders(stateValue);
                } else {
                    if (type === 'Infra-alert-automation') {
                        setPredictedInfraAlertHeaders(stateValue);
                    }
                    else if (type === 'Informational-automation') {
                        setPredictedInformationalHeaders(stateValue);
                    }
                    else {
                        setPredictedAlertHeaders(stateValue);
                    }
                }
                break;
            case 'runningAlertHeaders':
                if (type === 'Alert') {
                    setRunningAlertHeaders(stateValue);
                }
                break;
            case 'ExceptionCount':
                props.updateState('ExceptionCount', stateValue);
                break;
            default:
        }
    };

    const handleTabClick = (e) => {
        if (e && e.target && e.target.id) {
            console.log(e.target.id);
            if (e.target.id === 'long_running') {
                setSelectedIndex(1);
                props.handleTabSelected('Long Running');
            }
            else if (e.target.id === 'long_pending') {
                setSelectedIndex(2);
                props.handleTabSelected('Long Pending')

            }
            else if (e.target.id === 'infra_alert_automation') {
                setSelectedIndex(3);
                props.handleTabSelected('Infra Alerts')
            }
            else if (e.target.id === 'informational_automation') {
                setSelectedIndex(4);
                props.handleTabSelected('Informational Alerts')
            }
            else {
                setSelectedIndex(0);
                props.handleTabSelected('Dependency Failures')
            }

            setLoadedTabs([...loadedTabs, e.target.id]);
        }
    };

    //console.log(selectedIndex);
    /*
      const setUserPreferences = async (user) => {
        let body = { 'user': user };
        let filterPrefs = {};
        let response = await fetch(config.serverUrl + '/api/alerts/getUserPreferences', {
          method: 'POST',
          credentials: "include",
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json'
          },
          //     redirect: 'follow', // manual, *follow, error
          //    referrerPolicy: 'no-referrer',
          body: JSON.stringify(body)
        });
        let respJson = await response.json();
    
        if (respJson && respJson._source) {
          //console.log("preferences result", respJson);
    
    
          if (respJson._source.pAlertFilters) {
            setPAlertFilterSelections(respJson._source.pAlertFilters);
          }
          if (respJson._source.alertFilters) {
            filterPrefs.alertFilters = respJson._source.alertFilters;
          }
        }
      }
      */
    const ExecutionStatus = i18n.t('manageAutomation.ExecutionStatus');
    const Exceptions = i18n.t('manageAutomation.Exceptions');
    const predictedAnamolies = i18n.t('manageAutomation.predictedAnamolies');
    const LongRunning = i18n.t('manageAutomation.LongRunning');
    const All = i18n.t('manageAutomation.All');
    const Stopped = i18n.t('manageAutomation.Stopped');
    const Running = i18n.t('manageAutomation.Running');
    const Completed = i18n.t('manageAutomation.Completed');
    const LongPending = i18n.t('manageAutomation.LongPending');
    const InfraAlerts = i18n.t('manageAutomation.InfraAlertsAutomation');
    const Informational = i18n.t('manageAutomation.Informational');
    let resourceClick = props.resourceIssue;
    let queueStatusClick = props.queueStatus;
    let executionClick = props.executionClick;
    const messagesEndRef = useRef(null)

    const scrollToBottom = () => {
        messagesEndRef.current.scrollIntoView({ behavior: "smooth" })
    }

    useEffect(() => {
        if (resourceClick === false && queueStatusClick === false && props.anamoliesClick === true) {
            scrollToBottom();
        }
    }, [props.anamoliesClick]);

    return (
        <div>
            {
                resourceClick === true ?
                    <div>
                        <ResourceIssues
                            timeFilterSelections={props.timeFilterSelections}
                            filterData={alertFilterData}
                            filterSelections={alertFilterSelections}
                            disabledSelects={disabledSelects}
                            updateState={updateState}
                            status=''
                            alertType='reactive'
                            workspace={props.workspace} />
                    </div> :
                    queueStatusClick === true ?
                        <div>
                            <QueueStatus
                                timeFilterSelections={props.timeFilterSelections}
                                filterData={alertFilterData}
                                filterSelections={alertFilterSelections}
                                disabledSelects={disabledSelects}
                                updateState={updateState}
                                status=''
                                alertType='reactive'
                                workspace={props.workspace}
                            />
                        </div> :
                        executionClick === true || executionClick === false || (resourceClick === true && executionClick === true) || (queueStatusClick === true && executionClick === true) ?
                            <div>
                                <div className="manage-automation-page__r3">
                                    <div className="bx--col">
                                        <p className='padding-top manage-automation-page__subheading carbon-display-Regular-20'>{ExecutionStatus}</p>
                                    </div>
                                    <div className="manage-automation-page-alerts">
                                        <Tabs
                                            {...tabProps1.tabs}
                                            bx--grid--full-width
                                            aria-label="Tab navigation">
                                            <Tab {...tabProps1.tab} id='exceptions' bx--grid--full-width label={Exceptions} onClick={handleTabClick}>
                                                {Object.keys(props.timeFilterSelections).length !== 0 ?
                                                    <Suspense fallback={<div></div>}>
                                                        <Alerts
                                                            filterData={alertFilterData}
                                                            headers={alertHeaders}
                                                            filterSelections={alertFilterSelections}
                                                            timeFilterSelections={props.timeFilterSelections}
                                                            disabledSelects={disabledSelects}
                                                            updateState={updateState}
                                                            status='Exception'
                                                            alertType='reactive'
                                                            workspace={props.workspace}
                                                            bx--grid--full-width
                                                        />
                                                    </Suspense>
                                                    :
                                                    null}
                                            </Tab>
                                            <Tab {...tabProps1.tab} id='completed' label={Completed} onClick={handleTabClick}>
                                                {loadedTabs.includes('completed') ?
                                                    <Suspense fallback={<div></div>}>
                                                        <Alerts
                                                            filterData={alertFilterData}
                                                            headers={alertHeaders}
                                                            filterSelections={alertFilterSelections}
                                                            timeFilterSelections={props.timeFilterSelections}
                                                            disabledSelects={disabledSelects}
                                                            updateState={updateState}
                                                            status='Completed'
                                                            alertType='reactive'
                                                            workspace={props.workspace}
                                                            bx--grid--full-width />
                                                    </Suspense>
                                                    : null}
                                            </Tab>
                                            <Tab {...tabProps1.tab} id='running' label={Running} onClick={handleTabClick}>
                                                {loadedTabs.includes('running') ?
                                                    <Suspense fallback={<div></div>}>
                                                        <Alerts
                                                            filterData={alertFilterData}
                                                            headers={runningAlertHeaders}
                                                            filterSelections={alertFilterSelections}
                                                            timeFilterSelections={props.timeFilterSelections}
                                                            disabledSelects={disabledSelects}
                                                            updateState={updateState}
                                                            status='Running'
                                                            alertType='reactive'
                                                            workspace={props.workspace}
                                                            bx--grid--full-width />
                                                    </Suspense>
                                                    : null}
                                            </Tab>
                                            <Tab {...tabProps1.tab} id='stopped' label={Stopped} onClick={handleTabClick}>
                                                {loadedTabs.includes('stopped') ?
                                                    <Suspense fallback={<div></div>}>
                                                        <Alerts
                                                            filterData={alertFilterData}
                                                            headers={alertHeaders}
                                                            filterSelections={alertFilterSelections}
                                                            timeFilterSelections={props.timeFilterSelections}
                                                            disabledSelects={disabledSelects}
                                                            updateState={updateState}
                                                            status='Stopped'
                                                            alertType='reactive'
                                                            workspace={props.workspace}
                                                            bx--grid--full-width />
                                                    </Suspense>
                                                    : null}
                                            </Tab>
                                            <Tab {...tabProps1.tab} id='all' label={All} onClick={handleTabClick}>
                                                {loadedTabs.includes('all') ?
                                                    <Suspense fallback={<div></div>}>
                                                        <Alerts
                                                            filterData={alertFilterData}
                                                            headers={alertHeaders}
                                                            filterSelections={alertFilterSelections}
                                                            timeFilterSelections={props.timeFilterSelections}
                                                            disabledSelects={disabledSelects}
                                                            updateState={updateState}
                                                            status='All'
                                                            alertType='reactive'
                                                            workspace={props.workspace}
                                                            bx--grid--full-width />
                                                    </Suspense>
                                                    : null}
                                            </Tab>
                                        </Tabs>
                                    </div>
                                </div>
                                <div id={'Predicted_Anomalies'} className="bx--row bx--grid--full-width manage-automation-page__r4">

                                </div>
                                <div className="manage-automation-page__r5">
                                    <div className="bx--col">
                                        <p className='padding-top manage-automation-page__subheading carbon-display-Regular-20'>{predictedAnamolies}</p>
                                    </div>
                                    <div className="manage-automation-page-predictive-alerts">
                                        <Tabs
                                            {...tabProps2.tabs}
                                            selected={selectedIndex}
                                            bx--grid--full-width
                                            aria-label="Tab navigation">
                                            <Tab
                                                {...tabProps2.tab}
                                                id='dependency_failures'
                                                bx--grid--full-width
                                                label={i18n.t('manageAutomation.DependencyFailures')}
                                                onClick={handleTabClick}

                                            >
                                                {Object.keys(props.timeFilterSelections).length !== 0 ?
                                                    <Suspense fallback={<div></div>}>
                                                        <Alerts
                                                            filterData={pAlertFilterData}
                                                            headers={predictedAlertHeaders}
                                                            filterSelections={pAlertFilterSelections}
                                                            timeFilterSelections={props.timeFilterSelections}
                                                            disabledSelects={disabledSelects}
                                                            updateState={updateState}
                                                            alertType='Dependency failure'
                                                            status='Exception'
                                                            workspace={props.workspace}
                                                            bx--grid--full-width />
                                                    </Suspense>
                                                    : null}
                                            </Tab>
                                            <Tab {...tabProps2.tab} id='long_running' label={LongRunning} onClick={handleTabClick}>
                                                {loadedTabs.includes('long_running') ?
                                                    <Suspense fallback={<div></div>}>
                                                        <Alerts
                                                            filterData={pAlertFilterData}
                                                            headers={predictedAlertHeaders}
                                                            filterSelections={pAlertFilterSelections}
                                                            timeFilterSelections={props.timeFilterSelections}
                                                            disabledSelects={disabledSelects}
                                                            updateState={updateState}
                                                            alertType='Long running'
                                                            status='Exception'
                                                            workspace={props.workspace}
                                                            bx--grid--full-width />
                                                    </Suspense>
                                                    : null}
                                            </Tab>
                                            <Tab {...tabProps2.tab} id='long_pending' label={LongPending} onClick={handleTabClick}>
                                                {loadedTabs.includes('long_pending') ?
                                                    <Suspense fallback={<div></div>}>
                                                        <Alerts
                                                            filterData={pAlertFilterData}
                                                            headers={predictedAlertHeaders}
                                                            filterSelections={pAlertFilterSelections}
                                                            timeFilterSelections={props.timeFilterSelections}
                                                            disabledSelects={disabledSelects}
                                                            updateState={updateState}
                                                            alertType='Long pending'
                                                            status='Exception'
                                                            workspace={props.workspace}
                                                            bx--grid--full-width />
                                                    </Suspense>
                                                    : null}
                                            </Tab>
                                            {roles?.includes("azure_infra") ?
                                                <Tab {...tabProps2.tab} id='infra_alert_automation' label={InfraAlerts} onClick={handleTabClick}>
                                                    {loadedTabs.includes('infra_alert_automation') ?
                                                        <Suspense fallback={<div></div>}>
                                                            <Alerts
                                                                filterData={pAlertFilterData}
                                                                headers={predictedInfraAlertHeaders}
                                                                filterSelections={pAlertFilterSelections}
                                                                timeFilterSelections={props.timeFilterSelections}
                                                                disabledSelects={disabledSelects}
                                                                updateState={updateState}
                                                                alertType='Infra-alert-automation'
                                                                status='Exception'
                                                                workspace={props.workspace}
                                                                bx--grid--full-width
                                                            />
                                                        </Suspense>
                                                        : null}
                                                </Tab> : null}
                                            <Tab {...tabProps2.tab} id='informational_automation' label={Informational} onClick={handleTabClick}>
                                                {loadedTabs.includes('informational_automation') ?
                                                    <Suspense fallback={<div></div>}>
                                                        <Alerts
                                                            filterData={pAlertFilterData}
                                                            headers={predictedInformationalHeaders}
                                                            filterSelections={pAlertFilterSelections}
                                                            timeFilterSelections={props.timeFilterSelections}
                                                            disabledSelects={disabledSelects}
                                                            updateState={updateState}
                                                            alertType='Informational-automation'
                                                            status='Informational'
                                                            workspace={props.workspace}
                                                            bx--grid--full-width
                                                        />
                                                    </Suspense>
                                                    : null}
                                            </Tab>
                                        </Tabs>
                                    </div>
                                    <div ref={messagesEndRef}></div>
                                </div>
                            </div > : null
            }

        </div>
    );
};

export default AutomationOpsWorkspace;
